import { useState } from 'react'
import useDebounceCallback from 'src/common/hooks/helpers/useDebounceCallback'

export const useDebouncedSearch = (
  delay = 500
): {
  search: string
  debouncedSearch: string
  setSearch: (value: string) => void
} => {
  const [search, setSearch] = useState('')
  const [debouncedSearch, setDebouncedSearch] = useState('')

  const handleDebounce = useDebounceCallback(setDebouncedSearch, delay)

  const handleSearchChange = (value: string) => {
    setSearch(value)
    handleDebounce(value)
  }

  return { search, debouncedSearch, setSearch: handleSearchChange }
}
